import useSWR from 'swr'
import {fetchStoreCategoryVariations} from '@frontrow/console/src/entities/models/store-category-variation'

import {fetchItems} from '@frontrow/console/src/helpers/api-items'

const PIGGY_STORE_SWR_KEY = 'piggy-store'

export function usePiggyStore() {
  return useSWR(PIGGY_STORE_SWR_KEY, async () => {
    const [items, storeCategoryVariations] = await Promise.all([
      fetchItems(),
      fetchStoreCategoryVariations()
    ])

    return {
      itemsData: items,
      storeCategoryVariations
    }
  })
}

export {PIGGY_STORE_SWR_KEY}
